// extracted by mini-css-extract-plugin
module.exports = {"backlink":"BackLink-module--backlink--1mQH6"};